/* eslint-disable @next/next/no-img-element */
import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { getAssets } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import moment from "moment";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { CgClose } from "react-icons/cg";
import { FaSearch } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import Skeleton from "react-loading-skeleton";
import TimeAgo from "react-timeago";
import styles from "./list.module.scss";

export const PersonList = ({
  data,
  clickHandler,
  chatId,
  setCurrentChat,
  socket,
  connectedUserList,
  getConnectedUserList,
  loading,
  setLoading,
  customClasses,
  closeDrawer,
}) => {
  const [activeProfile, setActiveProfile] = useState();
  const [open, setOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const router = useRouter();

  // open chat box
  const handleClick = (person) => {
    if (clickHandler) clickHandler(person);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // get university list to add into friend list
  const getUserList = async (keyword) => {
    if (keyword && keyword.length >= 2 && keyword != "") {
      setLoading(true);
      setTimeout(async () => {
        await API.get(`/chat-service/get-users/${keyword}`).then((res) => {
          if (!res.error) {
            setUserList(res.data);
            setLoading(false);
          }
        });
      }, 2000);
    }
  };

  // add user into chat list
  const handleSubmit = async (payload) => {
    await API.post("/chat-service/add-user", {
      recieverId: parseInt(
        payload?.userTypeSlug === "mentor" ? payload?.id : payload?.universityId
      ),
      recieverType: payload?.userTypeSlug,
      senderTime: new Date(),
    }).then(async (res) => {
      if (!res.error) {
        handleClose();
        await getConnectedUserList();
        setUserList([]);
        setActiveProfile();
        router.push(`/app/student/messages?chatId=${res.data?.uid}`);
      }
    });
  };
  return (
    <>
      <div
        className={`${styles.list_wrapper} ${
          customClasses?.root ? customClasses?.root : ""
        }`}
      >
        <div className={styles.header_wrapper}>
          <button
            type="button"
            className={`btn btn-sm btn-outline-grey ${styles.btn_add_user}`}
            onClick={handleOpen}
          >
            New User
          </button>
          <CloseIcon className={styles.btn_close} onClick={closeDrawer} />

          <IconButton
            onClick={handleOpen}
            className={`${styles.btn_plus} relative`}
          >
            <AiOutlinePlus />
            <span className="uni-tooltip">New User</span>
          </IconButton>
        </div>

        <div className={styles.chatt_box_wrapper}>
          {connectedUserList &&
            connectedUserList?.length > 0 &&
            connectedUserList
              ?.sort((a, b) => {
                return b?.recentMsg?.chat_service_message_senderTime?.localeCompare(
                  a?.recentMsg?.chat_service_message_senderTime
                );
              })
              ?.map((item, index) => (
                <div
                  onClick={() => {
                    handleClick(item);
                    setCurrentChat(item?.receiver);

                    setActiveProfile(item);
                    if (closeDrawer) {
                      closeDrawer();
                    }
                  }}
                  key={`plist_${index}_${item.id}`}
                  className={
                    item && item?.uid == chatId
                      ? styles.active_chatt_box
                      : styles.chatt_box
                  }
                >
                  <div className={styles.chatt}>
                    <div className={styles.image_wrapper}>
                      <img
                        style={
                          item?.receiver?.userTypeSlug === "university"
                            ? { objectFit: "contain" }
                            : {}
                        }
                        alt={item?.receiver?.name ?? ""}
                        src={
                          item?.receiver?.media
                            ? item?.receiver?.media === null
                              ? getAssets("assets/student-avatar-big.png")
                              : item?.receiver?.media
                            : getAssets("assets/student-avatar-big.png")
                        }
                      />
                    </div>
                    <div className={styles.chatt_msg}>
                      <div>
                        <h4>{item?.receiver?.name}</h4>
                        {item?.recentMsg ? (
                          <p>
                            {item?.recentMsg?.chat_service_message_messages}
                          </p>
                        ) : (
                          <p>You Are Connected</p>
                        )}
                      </div>
                      {item?.recentMsg?.chat_service_message_createdAt && (
                        <span className={styles.time}>
                          {moment(
                            item?.recentMsg?.chat_service_message_senderTime
                          ).fromNow()}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>

      {/* Add user modal */}
      {/* <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="modal sm relative">
          <div className="modal_head">
            <h4 className={`${styles.title} modal_title`}>New Connect User</h4>
            <button className="cross_icon" onClick={handleClose}>
              <FiX />
            </button>
          </div>

          <div>
            <div className={styles.search_input_modal}>
              <input
                onChange={(e) => {
                  getUserList(e.target.value);
                }}
                type="text"
                placeholder="Search User"
              />
              <FaSearch className={styles.search_icon} />
            </div>
            <div className={styles.modal_body}>
              {userList &&
                userList?.length > 0 &&
                !loading &&
                userList?.map((item, i) => (
                  <div
                    onClick={() => {
                      setActiveProfile(item);
                    }}
                    key={`plist_${i}`}
                    className={
                      activeProfile && activeProfile.email === item.email
                        ? styles.active_chatt_box_modal
                        : styles.chatt_box
                    }
                  >
                    <div className={styles.chatt}>
                      <div className={styles.image_wrapper}>
                        <img
                          src={
                            item.mediaSrc
                              ? item.mediaSrc
                              : getAssets("assets/student-avatar-big.png")
                          }
                          alt={item.fullName ?? ""}
                        />
                      </div>
                      <div className={styles.chatt_msg}>
                        <div>
                          {item?.fullName && (
                            <h4 style={{ textTransform: "capitalize" }}>
                              {item?.fullName}
                            </h4>
                          )}
                          {item?.email && (
                            <p>
                              {item?.email} ({item?.userTypeSlug})
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              {loading &&
                Array(7)
                  .fill()
                  .map((item, i) => (
                    <Card
                      key={i}
                      sx={{
                        maxWidth: "100%",
                        padding: "0 15px",
                        margin: "-16px 0",
                        boxShadow: "none",
                      }}
                    >
                      <CardHeader
                        avatar={
                          <Skeleton
                            animation="wave"
                            variant="circular"
                            width={40}
                            height={40}
                          />
                        }
                        title={
                          <Skeleton
                            animation="wave"
                            height={10}
                            width="80%"
                            style={{ marginBottom: 6 }}
                          />
                        }
                        subheader={
                          <Skeleton animation="wave" height={10} width="40%" />
                        }
                      />
                    </Card>
                  ))}
              {userList?.length === 0 && !loading && (
                <h6 className={styles.no_found}>No User</h6>
              )}
            </div>
          </div>

          <div className={`modal_footer`}>
            <div className={`btn_group ${styles.btn_group}`}>
              <button
                className="btn btn-cancel btn btn-sm"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={() => handleSubmit(activeProfile)}
                type="submit"
                className="btn btn-secondary btn-sm"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </Modal> */}

      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "600px",
              paddingRight: "2px",
            },
          },
        }}
      >
        <DialogTitle>
          Start a New Chat
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 12,

              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CgClose />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{ padding: "0", minHeight: "50vh", maxHeight: "50vh" }}
        >
          <div className={styles.search_input_modal}>
            <input
              autoFocus
              onChange={(e) => {
                getUserList(e.target.value);
              }}
              type="text"
              placeholder="Search User"
            />
            <FiSearch
              className={styles.search_icon}
              style={{ fontSize: "20px" }}
            />
          </div>
          {userList &&
            userList?.length > 0 &&
            !loading &&
            userList?.map((item, i) => (
              <div
                onClick={() => {
                  setActiveProfile(item);
                }}
                key={`plist_${i}`}
                className={
                  activeProfile && activeProfile.email === item.email
                    ? styles.active_chatt_box_modal
                    : styles.chatt_box
                }
              >
                <div className={styles.chatt}>
                  <div className={styles.image_wrapper}>
                    <img
                      src={
                        item.mediaSrc
                          ? item.mediaSrc
                          : getAssets("assets/student-avatar-big.png")
                      }
                      alt={item.fullName ?? ""}
                    />
                  </div>
                  <div className={styles.chatt_msg}>
                    <div>
                      {item?.fullName && (
                        <h4 style={{ textTransform: "capitalize" }}>
                          {item?.fullName}
                        </h4>
                      )}
                      {item?.email && (
                        <p>
                          {item?.email} ({item?.userTypeSlug})
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          {loading &&
            Array(6)
              .fill()
              .map((item, i) => (
                <Card
                  key={i}
                  sx={{
                    maxWidth: "100%",
                    padding: "0 15px",
                    margin: "-16px 0",
                    boxShadow: "none",
                  }}
                >
                  <CardHeader
                    avatar={
                      <Skeleton
                        animation="wave"
                        variant="circular"
                        width={40}
                        height={40}
                      />
                    }
                    title={
                      <Skeleton
                        animation="wave"
                        height={10}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />
                    }
                    subheader={
                      <Skeleton animation="wave" height={10} width="40%" />
                    }
                  />
                </Card>
              ))}
          {userList?.length === 0 && !loading && (
            <div className={styles.no_found}>No User Found</div>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "12px 20px" }}>
          <button className="btn btn-cancel btn-md" onClick={handleClose}>
            Cancel
          </button>
          <button
            onClick={() => handleSubmit(activeProfile)}
            type="submit"
            className="btn btn-secondary btn-md"
            style={{ minWidth: "82px" }}
          >
            Add
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PersonList;
